// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__hGKfo","footer":"ChangeClinic_footer__2JMHe"};